{
  "general": {
    "title": "Titel"
  },
  "header": {
    "language": "Sprache",
    "help": "Hilfe",
    "help_modal": {
      "description": "Wenn Sie Hilfe benötigen oder Fragen haben, können Sie uns per E-Mail unter {mail} oder telefonisch unter {phone} kontaktieren."
    }
  },
  "fields": {
    "error_message": "Dieses Feld ist erforderlich",
    "invalid_email": "Ungültige E-Mail-Adresse",
    "invalid_end": "Die Endzeit muss nach der Startzeit liegen",
    "terms_required": "Sie müssen den Geschäftsbedingungen zustimmen, um fortzufahren",
    "invalid_phone": "Ungültige Telefonnummer. Versuchen Sie, die Ländervorwahl hinzuzufügen",
    "function_space_required": "Bitte wählen Sie einen Veranstaltungsraum aus, um fortzufahren",
    "function_space_configuration_error": "Kein Veranstaltungsraum kann Ihre gewählte Konfiguration aufnehmen. Bitte passen Sie die Anzahl der Gäste oder die Raumaufteilung an.",
    "function_space_date_unavailable": "Veranstaltungsräume, die Ihren Anforderungen entsprechen, sind am gewählten Datum nicht verfügbar. Bitte wählen Sie ein anderes Datum.",
    "function_space_conflict_error": "Dieser Funktionsraum ist bereits für einen überlappenden Zeitraum ausgewählt. Bitte wählen Sie einen anderen Raum oder passen Sie die Zeit an."
  },
  "reservation_steps": {
    "title": "Ihre Buchung:",
    "step_1": {
      "title": "Buchungsdetails",
      "sub_steps": {
        "services": "Benötigte Dienstleistungen",
        "location": "Wählen Sie eine Einrichtung",
        "email": "Kontaktdaten"
      }
    },
    "step_2": {
      "title": "Veranstaltungsräume",
      "sub_steps": {
        "basic_information_meeting_rooms": "Ihre Veranstaltung",
        "days": "Veranstaltungsdetails",
        "remarks": "Bemerkungen"
      }
    },
    "step_3": {
      "title": "Gästezimmer",
      "title_with_date": "Gästezimmer für {date}",
      "sub_steps": {
        "basic_information_hotel_rooms": "Details"
      }
    },
    "step_4": {
      "title": "Kontaktdaten",
      "sub_steps": {
        "basic_information": "Kontodaten",
        "contact_person": "Rechnungsadresse"
      }
    },
    "step_5": {
      "title": "Buchungsübersicht"
    }
  },
  "reservation_form": {
    "step_1": {
      "services": {
        "title": "Benötigte Dienstleistungen",
        "mice": "Veranstaltungsräume",
        "hotel": "Gästezimmer"
      },
      "location": {
        "title": "Wählen Sie Eine Einrichtung",
        "address": "Adresse",
        "phonenumber": "Telefonnummer"
      },
      "contract_email": {
        "title": "Kontaktdaten",
        "field": "E-Mail-Adresse"
      }
    },
    "step_2": {
      "basic_information": {
        "title": "Ihre Veranstaltung",
        "description_header": "",
        "description": "Bitte wählen Sie die Tage aus, an denen Ihre Veranstaltung stattfindet. Sie können mehrere Tage auswählen und die Details für jeden Tag ändern.",
        "fields": {
          "event_name": "Veranstaltungsname",
          "event_type": "Veranstaltungsart",
          "number_of_guests": "Anzahl der Gäste",
          "start_time": "Startzeit",
          "end_time": "Endzeit",
          "amount": "Anzahl",
          "total": "Gesamt",
          "add": "Hinzufügen",
          "emplacement": "Raumaufteilung"
        }
      },
      "add_day": {
        "title": "Möchten Sie Einen Weiteren Tag Hinzufügen?",
        "add_day": "Tag Hinzufügen",
        "add_item": "Produkt Hinzufügen",
        "day": "Tag {dayCount}",
        "date": "Datum",
        "select_date": "Datum Auswählen",
        "select_date_description": "Dies ist {day} Ihrer Veranstaltung. Sie können die Details für diesen Tag unten ändern.",
        "plenary_hall": "Plenarsaal",
        "sub_hall": "Nebensaal",
        "add_hall_description": "Um an diesem Tag weitere Veranstaltungsräume hinzuzufügen, klicken Sie auf die Schaltfläche \"Veranstaltungsraum hinzufügen\".",
        "add_hall_required": "Da Ihr Paket keinen Funktionsraum enthält, müssen Sie mindestens einen hinzufügen",
        "add_hall_required_error": "Bitte fügen Sie mindestens einen Funktionsraum hinzu, um fortzufahren",
        "add_hall_button": "Veranstaltungsraum Hinzufügen",
        "package_deal": "Verfügbare Pakete",
        "package_deal_chosen": "Ausgewähltes Paket",
        "package_deal_available": "Verfügbare Pakete",
        "package_deal_items": "Zusätzliche Produkte",
        "package_deal_items_included": "Enthaltene Produkte Anzeigen",
        "package_deal_spaces_included": "Inklusive Veranstaltungsräume",
        "additional_items": "Zusätzliche Produkte",
        "search": "Suchen",
        "no_items_found": "Keine Produkte gefunden",
        "choose_package_deal": "Wählen",
        "deselect_package_deal": "Entfernen"
      },
      "remarks": {
        "title": "Bemerkungen"
      },
      "item_types": {
        "audiovisual": "Audiovisuell",
        "food_beverage": "Speisen & Getränke",
        "other": "Andere"
      },
      "item_examples": {
        "audiovisual": "Zum Beispiel: Mikrofone",
        "food_beverage": "Zum Beispiel: Snacks",
        "other": "Zum Beispiel: Blumen"
      },
      "clone_day": "Tag Klonen",
      "space_selector": {
        "show_spaces": "Wählen Sie Einen Veranstaltungsraum",
        "hide_spaces": "Veranstaltungsräume Ausblenden",
        "no_selection": "Wir wählen einen geeigneten Veranstaltungsraum für Sie basierend auf den oben eingegebenen Informationen aus.",
        "capacities": "Kapazität Pro Raumaufteilung",
        "space_not_available": "Nicht verfügbar",
        "space_already_selected": "Bereits ausgewählt",
        "space_selected": "Ausgewählt",
        "select_space": "Auswählen",
        "show_more": "Mehr Räume Anzeigen",
        "show_less": "Weniger Räume Anzeigen",
        "show_unavailable": "Nicht verfügbare Räume Anzeigen",
        "hide_unavailable": "Nicht verfügbare Räume Ausblenden",
        "unavailable_matching_spaces": "Räume, die Ihren Anforderungen entsprechen, aber nicht verfügbar sind",
        "no_image": "Kein Foto verfügbar"
      }
    },
    "step_3": {
      "booking": {
        "title": "Gästezimmer",
        "title_with_date": "Gästezimmer für {date}",
        "available": "Verfügbar",
        "unavailable": "Nicht verfügbar",
        "available_rooms": "{n} verfügbar",
        "quantity": "Anzahl",
        "guests_per_room": "Gäste pro Zimmer",
        "guests_per_room_with_max": "Gäste pro Zimmer (max {max})",
        "max_guests": "Max {n} Gäste",
        "fields": {
          "name": "Gruppenname",
          "check_in_date": "Anreise",
          "check_out_date": "Abreise",
          "property": "Unterkunft für Gästezimmer",
          "number_of_rooms": "Anzahl der Zimmer",
          "persons_per_room": "Gäste pro Zimmer",
          "total_guests": "Gesamtzahl der Gäste",
          "room_type": "Zimmertyp",
          "late_check_out": "Später Check-out",
          "late_check_out_rooms": "Zimmer mit spätem Check-out",
          "breakfast": "Frühstück",
          "remarks": "Bemerkungen"
        },
        "progress_selected": "Ausgewählt",
        "max_capacity": "Max {count} Gäste",
        "sections": {
          "property": "Unterkunftsauswahl",
          "details": "Buchungsdetails", 
          "room_selection": "Zimmerauswahl"
        },
        "collapsed_summary": "{selected}/{total} Zimmer ausgewählt für {date}",
        "completed": "Abgeschlossen",
        "too_many_selected": "Zu viele ausgewählt",
        "incomplete": "Unvollständig"
      },
      "overnight_stay": {
        "title": "Möchten Sie Eine Weitere Übernachtung Hinzufügen?",
        "button": "Übernachtung Hinzufügen",
        "day": "Übernachtung"
      },
      "clone_room": "Übernachtung Klonen"
    },
    "step_4": {
      "account_details": {
        "title": "Kontodaten",
        "fields": {
          "first_name": "Vorname",
          "last_name": "Nachname",
          "company_name": "Firma",
          "email_address": "E-Mail-Adresse",
          "phone_number": "Telefonnummer"
        }
      },
      "billing_address": {
        "title": "Rechnungsadresse",
        "fields": {
          "address": "Adresse",
          "postal_code": "Postleitzahl",
          "city": "Stadt",
          "country": "Land"
        }
      },
      "contact_person_location": {
        "title": "Kontaktperson Vor Ort",
        "fields": {
          "copy": "Von Kontodaten Kopieren"
        }
      },
      "discount_code": "Aktionscode",
      "invoice_reference": "Rechnungsreferenz"
    },
    "step_5": {
      "offer": "Ihr Angebot",
      "reservation": "Ihre Buchung",
      "request": "Ihre Buchung",
      "offer_details": "Sie können hier alle Details einsehen. Sehen Sie auch die Vorschläge, die wir basierend auf unserer Expertise für Sie ausgewählt haben.",
      "download_pdf": "PDF Herunterladen",
      "hotel_only_meeting": "Aufenthalt",
      "discount": "Rabatt",
      "remarks": "Bemerkungen",
      "payment_method": "Zahlungsmethode",
      "payment_done": "Zahlung erfolgreich",
      "payment_succeeded": "Ihre Buchung wurde erfolgreich aufgegeben. Wir werden Ihnen eine E-Mail mit Ihren Details senden.",
      "payment_waiting": "Zahlung wird verarbeitet",
      "payment_processing": "Ihre Zahlung wird noch verarbeitet. Wir senden Ihnen eine E-Mail, sobald Ihre Zahlung erfolgreich ist.",
      "payment_failed": "Zahlung fehlgeschlagen",
      "payment_failed_message": "Bei der Verarbeitung Ihrer Zahlung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "sub_total_exclusive_vat": "Zwischensumme (ohne MwSt.)",
      "sub_total_exclusive_sales_tax": "Zwischensumme (ohne Verkaufssteuer)",
      "vat_amount": "{vat}% MwSt.",
      "sales_tax_amount": "{vat}% Verkaufssteuer",
      "terms_and_conditions": "Geschäftsbedingungen",
      "minutes_left": "Ihre Anfrage wird noch für 1 weitere Minute gehalten. Bitte schließen Sie Ihre Zahlung bald ab, um sie zu sichern. | Ihre Anfrage wird noch für <strong>{count} weitere Minuten</strong> gehalten. Bitte schließen Sie Ihre Zahlung bald ab, um sie zu sichern.",
      "seconds_left": "Sie haben noch <strong>1 Sekunde</strong>, um Ihre Zahlung abzuschließen. Ihre Anfrage läuft bald ab. | Sie haben noch <strong>{count} Sekunden</strong>, um Ihre Zahlung abzuschließen. Ihre Anfrage läuft bald ab.",
      "timer": {
        "title": "Zeit abgelaufen",
        "subtitle": "Entschuldigung, die Zeit für die Zahlung ist abgelaufen. Keine Sorge, wir haben Ihre Anfrage gespeichert und werden Sie so schnell wie möglich kontaktieren."
      },
      "basic_information": {
        "title": "Buchungsdetails",
        "event_name": "Veranstaltungsname",
        "event_type": "Veranstaltungsart"
      },
      "contact_information": {
        "title": "Kontaktinformationen",
        "contact_person_location": "Kontaktperson vor Ort",
        "account_details": "Kontodaten",
        "billing_address": "Rechnungsadresse"
      },
      "day": {
        "day": "Tag {dayCount}",
        "function_spaces": "Veranstaltungsräume",
        "additional_function_spaces": "Zusätzliche Veranstaltungsräume",
        "pax": "Anzahl der Gäste",
        "emplacement": "Raumaufteilung",
        "start_time": "Startzeit",
        "end_time": "Endzeit",
        "package_deals": "Pakete",
        "package_deals_details": "Das Paket, das für Sie bereitsteht, mit den zugehörigen Artikeln.",
        "package_deals_amount": "1 Person | {count} Personen",
        "package_deals_price": "{amount} pro Person",
        "additional_items": "Zusätzliche Artikel",
        "total": "Gesamt",
        "vat": "inkl. MwSt.",
        "sales_tax": "ohne Verkaufssteuer",
        "hall_rental": {
          "title": "Mietraum",
          "pax": "{pax} Personen"
        }
      },
      "hotel_room": {
        "title": "Gästezimmer",
        "price": "Preis",
        "room_type": "Zimmertyp",
        "rooms": "Zimmer",
        "number_of_rooms": "0 Zimmer | 1 Zimmer | {n} Zimmer",
        "per_room": "Gäste pro Zimmer",
        "pax_room": "0 Personen pro Zimmer | 1 Person pro Zimmer | {n} Personen pro Zimmer",
        "breakfast_status": "Frühstück enthalten | Frühstück nicht enthalten",
        "late_checkout": "Late Check-out",
        "nights": "0 Nächte | 1 Nacht | {n} Nächte",
        "per_night": "{amount} pro Zimmer pro Nacht",
        "breakfast_price": "{name}: {amount} pro Person pro Nacht",
        "late_checkout_price": "Late Check-out: {amount} pro Zimmer",
        "city_tax": "ohne Kurtaxe",
        "guests": "Gäste",
        "number_of_guests": "0 Gäste | 1 Gast | {n} Gäste"
      },
      "multi_venue_alert": {
        "title": "Standortübergreifende Buchung",
        "description": "Gästezimmer sind an anderen Standorten gebucht. Details unten."
      }
    },
    "modal": {
      "confirm_turn_down": {
        "title": "Sind Sie Sicher, Dass Sie Dieses Angebot Ablehnen Möchten?",
        "body": "Dies kann nicht rückgängig gemacht werden.",
        "checkbox": "Ich akzeptiere, dass ich dieses Angebot unwiderruflich ablehne."
      },
      "confirm_cancel": {
        "title": "Sind Sie Sicher, Dass Sie Diese Reservierung Stornieren Möchten?",
        "body": "Es gelten die Geschäftsbedingungen.",
        "checkbox": "Ich habe die <a href='{termsUrl}' target='_blank'>Geschäftsbedingungen</a> gelesen, verstanden und akzeptiert."
      },
      "confirm_accept": {
        "title": "Bestätigen Sie Ihre Reservierung",
        "body": "Es gelten die Geschäftsbedingungen.",
        "checkbox": "Ich habe die <a href='{termsUrl}' target='_blank'>Geschäftsbedingungen</a> gelesen, verstanden und akzeptiert."
      },
      "reservation_edited": {
        "title": "Vielen Dank. Ihre Änderungen wurden übernommen."
      },
      "reservation_submitted": {
        "title": "Vielen Dank. Es freut uns sehr, dass Sie daran interessiert sind, Ihre {meeting} mit uns zu organisieren.",
        "body": "Sie erhalten so bald wie möglich ein Angebot für Ihre Buchung.",
        "button": "Klicken Sie hier, um die Website von {locationName} zu besuchen"
      },
      "reservation_accepted": {
        "body": "Sie erhalten so bald wie möglich eine Bestätigung Ihrer Buchung."
      },
      "reservation_cancelled": {
        "title": "Sie haben die Reservierung für Ihre {meeting} storniert."
      },
      "reservation_turned_down": {
        "title": "Sie haben das Angebot für Ihre {meeting} abgelehnt."
      },
      "cancel_reason": {
        "text": "Stornierungsgrund",
        "placeholder": "Bitte geben Sie den Grund für die Stornierung dieser Reservierung an."
      },
      "turn_down_reason": {
        "text": "Grund für die Ablehnung",
        "placeholder": "Bitte geben Sie den Grund für Ihren Ablehnungsbescheid an."
      },
      "submitting": {
        "title": "Wir übermitteln Ihre Anfrage.",
        "subtitle": "Dies kann einige Zeit dauern. Bitte schließen Sie dieses Fenster nicht."
      },
      "request": {
        "loading_title": "Wir erstellen Ihre optionale Buchung.",
        "submitted_text": "Sie erhalten so bald wie möglich ein Angebot für Ihre Buchung."
      },
      "inquire": {
        "loading_title": "Wir erstellen Ihre Anfrage.",
        "submitted_text": "Wir werden uns so bald wie möglich mit Ihnen in Verbindung setzen."
      },
      "book": {
        "loading_title": "Wir berechnen den Preis.",
        "submitted_text": ""
      }
    },
    "buttons": {
      "edit_reservation": "Reservierung bearbeiten",
      "save_pdf": "Angebot als PDF speichern",
      "submit_offer": "Angebot anfordern",
      "next_step": "Nächster Schritt",
      "previous_step": "Vorheriger Schritt",
      "accept_offer": "Angebot annehmen",
      "cancel_offer": "Reservierung stornieren",
      "turn_down_offer": "Angebot ablehnen",
      "edit_offer": "Änderungen übernehmen",
      "request_proposal": "Angebot anfordern",
      "request": "Angebot anfordern",
      "inquire": "Anfragen",
      "book": "Jetzt buchen",
      "accept_booking": "Buchung bestätigen",
      "pay_booking": "Bezahlen",
      "cancel_booking": "Buchung stornieren"
    },
    "basket": {
      "cart": "Preisvorschau",
      "event": "Veranstaltung",
      "hotel_rooms": "Gästezimmer",
      "estimated_fees": "Geschätzte Gebühren",
    "event_subtotal": "Veranstaltung Zwischensumme",
    "hotel_room_subtotal": "Gästezimmer Zwischensumme",
      "guests": "Gäste",
      "meeting_space": "Tagungsraum",
      "additional_services": "Zusätzliche Dienstleistungen",
      "room": "Zimmer",
      "rooms": "Zimmer",
      "tax_breakdown": "Steueraufschlüsselung",
      "subtotal_with_rate": "Zwischensumme ({rate}% MwSt.)",
      "vat_with_rate": "MwSt. ({rate}%)",
      "sales_tax_with_rate": "Verkaufssteuer ({rate}%)",
      "total_excluding_tax": "Gesamtsumme ohne MwSt.",
      "total_excluding_sales_tax": "Gesamtsumme ohne Verkaufssteuer",
      "total_tax": "Gesamte MwSt.",
      "total_sales_tax": "Gesamte Verkaufssteuer",
      "total_including_taxes": "Gesamtsumme inkl. MwSt.",
      "total_including_sales_taxes": "Gesamtsumme inkl. Verkaufssteuer",
      "empty_cart": "Fügen Sie Artikel zu Ihrer Buchung hinzu, um Preisdetails zu sehen.",
      "pricing_unavailable": "Preisvorschau ist für diese Buchung nicht verfügbar. Sie erhalten detaillierte Preisinformationen nach Abschluss Ihrer Buchungsanfrage."
    }
  },
  "dropdown": {
    "no_results": "Keine Ergebnisse gefunden",
    "placeholder": "Option auswählen",
    "loading": "Laden..."
  },
  "switch": {
    "yes": "Ja",
    "no": "Nein"
  },
  "enums": {
    "payment_method": {
      "AT_LOCATION": "Vor Ort",
      "CREDIT_CARD": "Kreditkarte",
      "INVOICE": "Rechnung",
      "PRE_PAYMENT": "Vorauszahlung",
      "VOUCHER": "Gutschein"
    }
  },
  "price_types": {
    "per_guest": "Pro Gast",
    "per_unit": "Pro Einheit",
    "per_guest_explanation": "{price} pro Gast",
    "per_unit_explanation": "{price} Festpreis"
  }
}